import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Container, Link, Button, Typography, TableCell, TableRow, Table, TableBody } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { genfunction } from 'helpers'
import * as underscore from 'underscore'
import ReactHtmlParser from 'react-html-parser';
import { useLocation } from "react-router-dom";

import { actionStartAppLoader, actionEndAppLoader } from 'actions/actionAppLoader';
import { actionGetGATickets, actionUpdateQuantityToProduct } from 'actions';
import { actionShopCartAddGATicket } from 'actions';
import ErrorHandling from 'components/ErrorHandling/ErrorHandling';
import DialogeBox from 'components/DialogeBox/DialogeBox';
import GAGroupItem from './components/GAGroupItem'
import { Hidden } from '@material-ui/core';
import { actionResetPaymentTransaction } from 'actions';

const { DefaultGATicketDisplayAreaNo, TicketPageHeader, OrderItemsInCartError } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(5)
        }
    },
    headerText: {
        paddingBottom: 15,
        textAlign: "center"
    },
    primarycolor: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    footertablecell: {
        paddingRight: 0
    }
}));

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

const GATickets = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [errorMsg, seterrorMsg] = useState("");
    const [tnc, settnc] = useState({
        tncOpen: false,
        tncMessage: "",
    })
    const [DisplayArea, setDisplayArea] = useState(DefaultGATicketDisplayAreaNo);
    const GATickets = useSelector(state => state.reducerGaTicket.GATickets);
    const GATicketsError = useSelector(state => state.reducerGaTicket.GATicketsError);
    const GADisplayAreas = useSelector(state => state.reducerGaTicket.GADisplayAreas);
    const GACouponCode = useQuery().get("coupon");

    const gaTickets = useSelector(state => state.reducerShopCart.GATickets);
    const membershipPackages = useSelector(state => state.reducerShopCart.MembershipPackages);
    const events = useSelector(state => state.reducerShopCart.events);
    const paymenttranstate = useSelector(state => state.reducerPaymentTransaction.Payment);
    const giftcards = useSelector(state => state.reducerGiftCards);
    const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);
    const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);

    useEffect(() => {
        if (events && events.length == 0 && membershipPackages && membershipPackages.length == 0 && gaTickets && gaTickets.length == 0 &&
            giftcards.giftcards && giftcards.giftcards.length == 0 && donationProducts && donationProducts.length == 0 && paymenttranstate.hasOwnProperty("ReceiptNo") && paymenttranstate.ReceiptNo.toString().length > 0) {
            actionResetPaymentTransaction(dispatch);
        }
    }, []);

    useEffect(() => {
        if (GATickets && GATickets.length > 0) {
            actionEndAppLoader(dispatch);
        }
    }, [GATickets])

    useEffect(() => {
        seterrorMsg(GATicketsError);
    }, [GATicketsError])

    useEffect(() => {
        actionStartAppLoader(dispatch);
        if (props.match.path == "/gatickets/Area/:id") {
            var areaNo = props.match.params.id;
            setDisplayArea(areaNo);
            actionGetGATickets(dispatch, areaNo, GACouponCode);
        }
        else
            actionGetGATickets(dispatch, DisplayArea, GACouponCode);
    }, [])

    const errorcancelhandle = () => {
        seterrorMsg("");
    }

    const settnchandler = (ProductID) => {
        let ticket = GATickets.find(x => x.ProductID === ProductID);
        if (ticket) {
            settnc({
                tncOpen: true,
                tncMessage: ReactHtmlParser(genfunction.replaceEscapeCharacters(ticket.TermsConditions))
            })
        }
        else {
            settnc({
                tncOpen: false,
                tncMessage: ""
            })
        }
    }

    const changeQuantityHandler = (refrence, value) => {
        actionUpdateQuantityToProduct(dispatch, refrence.tourProductID, value);
    }

    const getGroupedGATickets = () => {

        var SellTickets = GATickets.filter(ticket => new Date().getTime() >= new Date(ticket.ProductSellStartDate).getTime() && new Date().getTime() <= new Date(ticket.ProductSellEndDate).getTime());
        SellTickets = SellTickets.filter(ticket => DisplayArea == 0 || ticket.DisplayArea == DisplayArea)
        let sortticket = underscore.sortBy(SellTickets, ticket => ticket.GATicketDepartments[0].DepartmentSortOrder);
        let group = underscore.groupBy(sortticket, (ticket) => { return ticket.GATicketDepartments[0].DepartmentName; });
        return group;
    }

    const getTotalAmount = () => {
        let amount = {
            tax: 0,
            total: 0,
        }

        GATickets.forEach(ticket => {
            amount.tax += ticket.TaxAmount;
            amount.total += ticket.TotalAmount;
        });

        return amount;
    }

    const getDisplayAreaText = () => {
        var DA = GADisplayAreas.find(da => da.DisplayAreaNo == DisplayArea && da.ShowOnline === true);
        if (DA)
            return DA.DisplayText;
        else
            return "";
    }

    const AddToCartHandler = () => {

        if (orderProducts && orderProducts.length > 0) {
            seterrorMsg(OrderItemsInCartError);
            return;
        }

        var tickets = GATickets.filter(ticket => ticket.Quantity > 0);
        if (tickets && tickets.length > 0) {
            var minQtytickets = GATickets.find(ticket => ticket.Quantity > 0 && ticket.Quantity < ticket.MinQuantity);
            if (minQtytickets) {
                seterrorMsg((genfunction.IsNotNullOrEmptyOrUndefined(minQtytickets.WebProductName) ? minQtytickets.WebProductName : minQtytickets.ProductName)
                    + " (Please select at least " + minQtytickets.MinQuantity + " quantity)");
                return;
            }
            else {
                let newtickets = tickets.map(ticket => ({ ...ticket, CouponCodeApplied: (ticket.OriginalPrice && ticket.Price < ticket.OriginalPrice) ? GACouponCode : null, OriginalPrice: (ticket.OriginalPrice ? ticket.OriginalPrice : ticket.Price) }))
                actionShopCartAddGATicket(dispatch, newtickets);
                props.history.push('/checkout');
            }
        }
        else {
            seterrorMsg("Please select quantity first");
        }
    }

    return (
        <Container id="vt_page_gaticket" className={classes.root}>
            <ErrorHandling msg={errorMsg} open={errorMsg != ""} handleclose={errorcancelhandle} />

            <Typography variant="h1" component="h1" color="primary" className={classes.headerText}
                style={{ marginTop: 0 }}>{TicketPageHeader}</Typography>


            <Typography variant="subtitle1" color="primary" className={classes.headerText}>{ReactHtmlParser(genfunction.replaceEscapeCharacters(getDisplayAreaText()))}</Typography>
            <Grid container justify="center" spacing={1}>
                <Grid item xs={12} md={7}>
                    {underscore.map(getGroupedGATickets(), (items, key) => {
                        return (
                            <GAGroupItem GroupHeader={key} GroupItems={underscore.sortBy(items, "SortOrder")} ChangeQuantityHandler={changeQuantityHandler} InfoClickHandler={settnchandler}></GAGroupItem>
                        )
                    })}
                </Grid>
                <Grid container item xs={12} md={7}>
                    <Grid item xs={6}></Grid>
                    <Grid item xs={6} align="right">
                        <Grid>
                            <Table size="small" style={{ maxWidth: 150 }}>
                                <TableBody>
                                    <TableRow>
                                        <TableCell className={classes.footertablecell}>Tax</TableCell>
                                        <TableCell className={classes.footertablecell} align="right">{genfunction.ccyFormat(getTotalAmount().tax)}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className={classes.footertablecell}>Total</TableCell>
                                        <TableCell className={classes.footertablecell} align="right">{genfunction.ccyFormat(getTotalAmount().total)}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                            <Button style={{ marginTop: 10 }} color="primary" variant="contained" onClick={AddToCartHandler}>Add to cart</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <DialogeBox open={tnc.tncOpen} title={"Terms and Conditions"}
                message={tnc.tncMessage}
                button1text={"Close"}
                button1clickhandler={() => { settnchandler(0) }}>
            </DialogeBox>
        </Container>
    );
};

export default GATickets;
